import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'amountConverter'
})
export class AmountConverterPipe implements PipeTransform {

    transform(value: number | string, locale?: string, min: number = 2): string {
        return new Intl.NumberFormat(locale, {
            minimumFractionDigits: min
        }).format(Number(value));
    }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/amountConverter.pipe.ts